import React from 'react'
import {
  Box,
  Typography,
  Grid,
  Chip,
  Card,
  CardContent,
  Stack,
  Divider,
  Link,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material"
import sprite_ from '../../sass/sprite.module.sass'
import {
  ExpandMore as ExpandMoreIcon,
  ContentCopy as ContentCopyIcon,
  Launch as LaunchIcon,
} from '@mui/icons-material'
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, IconButton, Tooltip,
} from "@mui/material"
import { getTitle } from '../../function/string'
import { useAccordionStyles } from '../../style/lookup'

interface SmfCommonProps {
  smfData: any
}

const Smf: React.FC<SmfCommonProps> = ({ smfData }) => {
  const accordionClasses: any = useAccordionStyles()
  const [query, setQuery] = React.useState("")

  const results = smfData?.data?.emailSearchResultSmf ? smfData?.data?.emailSearchResultSmf : []

  const filtered = React.useMemo(() => {
    const q = query.trim().toLowerCase()

    const withUrl = (Array.isArray(results) ? results : []).filter(
      (r: any) => r?.socialProfileUrl != null && String(r.socialProfileUrl).trim() !== '',
    )

    if (!q) return withUrl
    if (!q) return results
    return results.filter((r: any) =>

      [r.inputProfileName, r.social, r.socialProfileUrl]
        .filter(Boolean)
        .some((v) => String(v).toLowerCase().includes(q)),
    )
  }, [query, results])


  const email = results[0]?.inputProfileName ?? ""

  return (
    <Accordion
      classes={accordionClasses}
      square
      sx={{ width: '100%' }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ width: '100%' }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%' }}>
          <Box
            className={sprite_['social__small_' + smfData?.from]}
          />
          <Typography
            variant="semiBold"
            sx={{ textTransform: 'capitalize' }}
          >
            {getTitle(smfData.from)}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Divider
          sx={{
            margin: '-5px 0px 15px 0px',
            border: `0.1px solid rgba(46, 151, 213, 0.3)`,
          }}
        />
        <Box display="flex" flexDirection="column" gap={2}>
          <TableContainer component={Paper} elevation={0}
            sx={{ borderRadius: 2, border: (t) => `1px solid ${t.palette.divider}` }}>
            <Table size="small" aria-label="email search result table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Social</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Profile URL</TableCell>
                  {/* <TableCell sx={{ fontWeight: 700 }} align="center">Open</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {filtered.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <Typography variant="body2" color="text.secondary">No results</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filtered.map((row: any, idx: number) => {
                    const hasUrl = Boolean(row.socialProfileUrl)
                    return (
                      <TableRow key={`${row.social}-${idx}`} hover>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>
                          <Chip
                            label={row.social}
                            size="small"
                            color={hasUrl ? "primary" : "default"}
                            variant={hasUrl ? "filled" : "outlined"}
                          />
                        </TableCell>
                        <TableCell>
                          {hasUrl ? (
                            <Link href={row.socialProfileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              underline="hover">
                              {row.socialProfileUrl.length > 45
                                ? `${row.socialProfileUrl.slice(0, 45)}...`
                                : row.socialProfileUrl}
                            </Link>
                          ) : (
                            <Typography variant="body2" color="text.disabled">—</Typography>
                          )}
                        </TableCell>
                        {/* <TableCell align="center">
                          {hasUrl ? (
                            <Tooltip title="Открыть в новой вкладке">
                              <IconButton
                                size="small"
                                component="a"
                                href={row.socialProfileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`Open ${row.social}`}
                              >
                                <LaunchIcon fontSize="inherit" />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <Typography variant="body2" color="text.disabled">—</Typography>
                          )}
                        </TableCell> */}
                      </TableRow>
                    )
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>

        </Box>

      </AccordionDetails>
    </Accordion>
  )
}

export default Smf